export default {
  header: "#ffffff",
  headerMenuBar: "#061178",
  sidebar: "#10239e",
  //"sidebar-main-menu": "#21859c",

  "sidebar-main-menu": "#FCE181",

  "sidebar-sub-menu": "#4b6aec",
  background: "#f0f5ff",
  footer: "#adc6ff",
  sidebarBackground: "#cfd8dc",
  popupMenu: "#9e6216",
  final_header: "rgb(2, 102, 112)",
  final_footer:"rgb(2, 102, 112)",
//   final_side: "#21859c",
//   final_side_sub: "#DEEBF7",
//   final_side_inner: "#DEEBF7",
final_side: "#FCE181",
final_side_sub: "#FEF9C7",
final_side_inner: "#EDEAE5",



  white: "#FFFFFF",
  black: "#000000",

  textcolor:"#000000",
  bordercolor:"#ffffff",
  text_sub_color:"#000000", // currently using for text color


  final_side_outer: "#9FEDD7",
  gray: "gray",
  indigo: "indigo",
  main_footer: "#3f51b5",
  // graphical:"#21859c",

  // sidebar: "#21859c",
  graphical:"#3f51b5",

  sidebar:"#3f51b5",
  // modalheader:"#21859c",
  // modalwindow:"#DEE555",
  // menu_textcolor:"white",
  // submenu_textcolor:"black",
  // select_color:"#63A9B9",
  // select_text_color:"#000000",
    // select_color:"#63A9B9",
  // select_text_color:"#000000",
  // modalwindow_1:"#DEEBF7",
  // modalheader_1:'#21859c',
  // modalheader_1_text:"#ffffff",
  // modalbox:"#DEEBF7",
  // modalbox_text:"#000000"
  // modalbox_1:"#DEEBF7",
  // modalbox_text_1:"#000000"

};
